module.exports = __webpack_public_path__ + "img/big-issue-quote-person.2dfb710e.svg";